export function breadcrumbJsonLd(crumbs) {
  const origin = window.location.origin;
  const items = [
    { name: "Home", url: `${origin}/` },
    ...crumbs.filter(Boolean).map((c) => ({
      name: c.label,
      url: `${origin}${c.to || window.location.pathname}`,
    })),
  ];
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: it.url,
    })),
  };
}
